import {SubscriptionType} from '@enums';

/**
 * Max number of gallery photo slots per subscription tier.
 * Classique (free) = 0, Soutient = 2, Premium = 5, Eternal = 10.
 */
export const SUBSCRIPTION_GALLERY_SLOTS: Record<SubscriptionType, number> = {
	[SubscriptionType.Classique]: 0,
	[SubscriptionType.Soutient]: 2,
	[SubscriptionType.Premium]: 5,
	[SubscriptionType.Eternal]: 10
};
